MS = window.MS || {};
window.$ = window.$ || jQuery;

(function( $ ) {
    MS.sultrysalt = {
        init: function() {
          MS.sultrysalt_sticky_nav.init();
          MS.sultrysalt_nav.init();
          MS.sultrysalt_scroll_progress.init();
          MS.sultrysalt_hero.init();
          MS.sultrysalt_recipe_transporter.init();
          MS.footer.init();
          this.initilializeDynamicModules();

        },
        initilializeDynamicModules: function () {
          MS.sultrysalt_persistent_bar.init();
        }
    };


    // Browser detection constants
    //
    // Usage:
    //
    // if ( IS_IE ) {
    //  // Browser is IE
    // }
    //
    // ------------------------------------------------
    var ua = window.navigator.userAgent;

    Object.defineProperties(window, {

      // window.IS_IE  or IS_IE
      IS_IE: {
        value: /(MSIE\s|Trident\/)/ig.test(ua)
      },

      // window.IS_EDGE or IS_EDGE
      IS_EDGE: {
        value: /Edge\//ig.test(ua)
      }

    });

})(jQuery);

MS.sultrysalt.init();
